module.exports = __webpack_public_path__ + "img/bghe3.eb7051dd.png";